import { KisweSelectOption } from '@/modules/kisweui/types'
import store from '@/store'
import { NimbleRegion } from '@/types/admin'
import { computed,  onMounted,  onUnmounted } from '@vue/composition-api'

const useNimbleRegions = () => {
  const nimbleregions = computed(() => {
    return store.state.admin.nimbleregions
  })

  const nimbleRegionsSelectOptions = computed((): KisweSelectOption[] => {
    const sortedKeys = Object.keys(nimbleregions.value).sort()
    return sortedKeys.map((key) => ({ label: nimbleregions.value[key].name, value: key }))
  })

  const getNimbleRegion = (region: string): NimbleRegion => {
    return nimbleregions.value[region]
  }

  onMounted(async () => {
    try {
      await store.dispatch.admin.subscribeNimbleRegions()
    } catch (error) {
      console.error('Could not register useNimbleRegions', error)
    }
  })

  onUnmounted(async () => {
    try {
      await store.dispatch.admin.unsubscribeNimbleRegions()
    } catch (error) {
      console.error('Could not unregister useNimbleRegions', error)
    }
  })

  return {
    nimbleregions,
    nimbleRegionsSelectOptions,
    getNimbleRegion
  }
}

export default useNimbleRegions
